<template>
  <div id="app">
    <Header />
    <div id="ww">
      <div id="contents">
        <router-view />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/common/Header.vue";
import Footer from "./components/common/Footer.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* margin-top: 60px; */

  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f2f2f2;
}

#contents {
  text-align: center;
  margin: 20px;
}
</style>
